import { ServiceContractDelegation } from "../ServiceContractDelegation/ServiceContractDelegation";

export class ServiceContactDelegation {
    constructor(
        id,
        name,
        apellido,
        correoElectronico,
        contactPhoneNumber,
        serviceContractDelegation,
        deletedAt
    ) {
        this.id = id;
        this.name = name;
        this.apellido = apellido;
        this.correoElectronico = correoElectronico;
        this.contactPhoneNumber = contactPhoneNumber;
        this.serviceContractDelegation = serviceContractDelegation;
        this.deletedAt = deletedAt;
    }
    static createFromResponseData(data) {
        return new ServiceContactDelegation(
            data.id ?? null,
            data.name ?? null,
            data.apellido ?? null,
            data.correoElectronico ?? null,
            data.contactPhoneNumber ?? null,
            ServiceContractDelegation.createFromResponseData(data.serviceContractDelegation),
            data.deletedAt ?? null
        );
    }
}